export type Point = { x: number; y: number; score: number; name: string };
export type PoseFrame = { points: Record<string, Point>; confidence: number; timestamp: number };

export type MovementData = {
  movementEnergy: number;
  leftHandSpeed: number;
  rightHandSpeed: number;
  verticalPosition: number;
  horizontalDirection: number;
  verticalDirection: number;
  bodyExpansion: number;
  gestureScale: number;
  directionLabel: string;
};

export type VisualMode = 'trail' | 'ribbon' | 'particle' | 'shape' | 'paint';
export type ScaffoldLevel = 1 | 2 | 3 | 4;
export type CameraView = 'camera' | 'silhouette' | 'visuals';

export const EMPTY_MOVEMENT: MovementData = {
  movementEnergy: 0, leftHandSpeed: 0, rightHandSpeed: 0, verticalPosition: .5,
  horizontalDirection: 0, verticalDirection: 0, bodyExpansion: .3, gestureScale: .3,
  directionLabel: '準備',
};
